import { CONFIG } from '../../core/config';
import { ViewModel } from '../view-model';
import { IndustryHierarchyItemBase } from './industry-hierarchy-item';

export class Installation extends IndustryHierarchyItemBase implements ViewModel {
  readonly friendlyTypeNameSingular: string = 'Installation';
  readonly apiRoute: string = CONFIG.apiRoutes.installation;

  businessId: string;
  loadFromJson(data) {
    super.loadFromJson(data);
    this.businessId = data.businessId;
  }
}

